import { Link } from "react-router-dom";
import { useLang } from "../../context/LanguageContext";
import { getFeaturedProducts, getProductUi } from "../../data/products";
import ProductCard from "./ProductCard";
import { ConvocoreCallout } from "./ProductCallouts";
import "./Products.css";

export default function ProductsHomeSection() {
  const { lang } = useLang();
  const ui = getProductUi(lang);
  const featuredProducts = getFeaturedProducts();

  return (
    <section id="products" className="digital-products-section digital-products-home">
      <div className="digital-products-container">
        <div className="digital-products-heading">
          <div>
            <span className="digital-products-eyebrow">{ui.eyebrow}</span>
            <h2>{ui.homeTitle}</h2>
          </div>
          <div className="digital-products-heading__side">
            <p>{ui.homeSubtitle}</p>
            <Link className="product-button product-button--secondary" to="/productos">
              {ui.viewCatalog}
            </Link>
          </div>
        </div>

        <div className="digital-products-grid">
          {featuredProducts.map((product) => (
            <ProductCard key={product.id} product={product} lang={lang} ui={ui} />
          ))}
        </div>

        <ConvocoreCallout ui={ui} />
      </div>
    </section>
  );
}
